<template>
  <div class="model-1">
	  <div class="adv-wrapper" :style="{backgroundColor:editablePageConfig.editable_page_config_content.back_color}">
	  <div class="wrapper" v-bind:style="getBannerStyle" v-if="editablePageConfig.editable_page_config_content.show_format==1">
	  	  <div class="bd" :style="{top}">
			  <img v-for="(item,index) in editablePageConfig.editable_page_config_content.adv" :key="index" :style="getBannerStyle" v-lazy="item.image" @click="goAdUrl(item.link)"/>
		  </div>
		  <div class="hd" v-if="editablePageConfig.editable_page_config_content.adv.length>1">
			  <div v-for="(item,index) in editablePageConfig.editable_page_config_content.adv" :key="index" class="li" :class="{'on':activeIndex==index}"></div>
		  </div>
	  </div>	  
	  <mt-swipe v-else v-bind:style="getBannerStyle" :showIndicators="isShowIndicators">
	    <mt-swipe-item v-for="(item,index) in editablePageConfig.editable_page_config_content.adv" :key="index">
	  		<img :style="getBannerStyle" v-lazy="item.image" @click="goAdUrl(item.link)"/>
	    </mt-swipe-item>
	  </mt-swipe>
	  </div>
  </div>
</template>

<script>
export default {
  name: 'Model1',
  data () {
    return {
		activeIndex: 0,
		time_interval:null
    }
  },
  props: ['editablePageConfig','editablePage'],
  computed: {
	itemSize(){
		let itemWidth = parseFloat(this.editablePageConfig.editable_page_config_content.image_width)
		let itemHeight = parseFloat(this.editablePageConfig.editable_page_config_content.image_height)
		if(isNaN(itemWidth) || itemWidth<=0){
		      itemWidth=750
		    }
		    if(isNaN(itemHeight) || itemHeight<=0){
		      itemHeight=376
		    }
				  const { width, height } = window.screen
				  var imageWidth=width-parseFloat(this.editablePage.editable_page_theme_config.page_margin)*2
				  
		return {
		  width: imageWidth,
		  height: itemHeight/itemWidth*imageWidth
		}
	},  
    getBannerStyle: function () {
      return {
        width: this.itemSize.width+'px',
        height: this.itemSize.height+'px'
      }
    },
    isShowIndicators () {
      if (this.editablePageConfig.editable_page_config_content.adv.length>1) {
        return true
      }
      return false
    },
	top () {
	  return -this.activeIndex * this.itemSize.height + 'px'
	}
  },
  beforeDestroy: function () {
    if(this.time_interval){
		clearInterval(this.time_interval)
	}
  },
  mounted () {
    if(this.editablePageConfig.editable_page_config_content.show_format==1 && this.editablePageConfig.editable_page_config_content.adv.length>1){
		let _this = this
		this.time_interval = setInterval(function () {
		  if (_this.activeIndex < (_this.editablePageConfig.editable_page_config_content.adv.length-1)) {
		    _this.activeIndex += 1
		  } else {
		    _this.activeIndex = 0
		  }
		}, 2000)
	}
  },
  methods: {
    goAdUrl (url) {
      this.$router.push({ path: url })
    }
  }
}
</script>

<style scoped lang="scss">
	.model-1 .adv-wrapper .wrapper{position:relative}
.model-1 .adv-wrapper{
   overflow: hidden;
   position:relative;
   font-size: 0;
   border-radius: 5px;
}
.model-1 .adv-wrapper .bd{position:relative;transition: top 0.5s;}
.model-1 .adv-wrapper .hd {
   position:absolute;
   bottom:10px;
   text-align: center;
   width: 100%;
}
.model-1 .adv-wrapper .hd .li{
   display: inline-block;
   width:10px;
   height: 10px;
   border-radius:10px;
   background-color: rgba(0,0,0,.5);
   margin:0 5px;
}
.model-1 .adv-wrapper .hd .li.on{
   background-color: rgba(255,255,255,.5);
}
</style>
